export abstract class RmIframeEventType {
    static RemitaOpen = "RemitaOpen";
    static RemitaClose = "RemitaClose";
    static RemitaError = "RemitaError";
    static RemitaConfigError = "RemitaConfigError";
    static RemitaCloseAppLoader = "RemitaCloseAppLoader";
}



// WEBPACK FOOTER //
// ../inline/src/modules/shared/models/rm-iframe-event-type.ts